/**
 * Skeleton placeholder shown while a tool chunk lazy-loads, so switching tools
 * on the donut feels smooth instead of flashing a spinner. Roughly mirrors a
 * tool form: intro line, a couple of field rows, and an action button.
 */

import { Skeleton } from "@/components/ui/skeleton";

const ToolSkeleton = () => (
  <div className="space-y-5" aria-hidden="true">
    {/* Intro */}
    <div className="space-y-2">
      <Skeleton className="h-3 w-1/3" />
      <Skeleton className="h-3 w-4/5" />
    </div>

    {/* Field rows */}
    <div className="space-y-2">
      <Skeleton className="h-3 w-1/4" />
      <Skeleton className="h-9 w-full rounded-md" />
    </div>
    <div className="space-y-2">
      <Skeleton className="h-3 w-1/4" />
      <Skeleton className="h-9 w-full rounded-md" />
    </div>

    {/* Dropzone */}
    <Skeleton className="h-24 w-full rounded-lg" />

    {/* Action button */}
    <Skeleton className="h-10 w-full rounded-md" />
  </div>
);

export default ToolSkeleton;
